import { ActionsObservable, combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, pluck } from 'rxjs/operators'

import * as api from 'api/report/callSummary'
import { fromRequest } from 'utils/api'
import { createCSVDownload, csvFilenameFromQuery } from 'utils/csv'

import * as actions from './actions'

const fetchCallsMade = (action$: ActionsObservable<any>) =>
  action$.pipe(
    ofType(actions.fetchCallsMade.toString()),
    pluck('payload'),
    mergeMap(({ queryConfig, options }) =>
      fromRequest(api.fetchSearch(queryConfig, options)).pipe(
        map((response) =>
          actions.fetchCallsMadeSuccess({ queryConfig, response })
        ),
        catchError((error) => {
          console.error('Error while fetching calls made:', error)
          return of(actions.fetchCallsMadeFailed({ queryConfig, error }))
        })
      )
    )
  )

const fetchCallData = (action$: ActionsObservable<any>) =>
  action$.pipe(
    ofType(actions.fetchCallData.toString()),
    pluck('payload'),
    mergeMap(({ queryConfig, options }) => {
      return fromRequest(api.fetchSimpleReport(queryConfig, options)).pipe(
        map((response) =>
          actions.fetchCallDataSuccess({ queryConfig, response })
        ),
        catchError((error) => {
          console.error('Error while fetching calls made:', error)
          return of(actions.fetchCallDataFailed({ queryConfig, error }))
        })
      )
    })
  )

const exportCallReportData = (action$: ActionsObservable<any>) =>
  action$.pipe(
    ofType(actions.exportCallData.toString()),
    pluck('payload'),
    mergeMap(({ queryConfig, options }) => {
      return fromRequest(api.fetchSearchExportCSV(queryConfig, options)).pipe(
        map((response) => {
          createCSVDownload(response, csvFilenameFromQuery(queryConfig))
          return actions.exportCallDataSuccess({ queryConfig })
        }),
        catchError((error) => {
          console.error('Error while exporting calls data:', error)
          return of(actions.exportCallDataFailed({ queryConfig, error }))
        })
      )
    })
  )

export default combineEpics(fetchCallsMade, fetchCallData, exportCallReportData)
